import React from 'react';
import './HistoryRounds.css';

const HistoryRounds = ({ rounds, loading, onLoadHistory, onBallClick }) => {
  const hasRounds = rounds && rounds.length > 0;
  const lastRound = hasRounds ? rounds[rounds.length - 1] : null;
  const hasMore = !lastRound || lastRound.roundNumber > 1;

  return (
    <div className="history-rounds-container">
      <h2 className="section-title">历史轮次</h2>
      
      <div className="history-rounds-card">
        {!hasRounds ? (
          <div className="empty-state">
            <p>{loading ? '正在获取链上数据...' : '点击下方按钮加载历史数据'}</p>
          </div>
        ) : (
          <div className="rounds-list">
            {rounds.map(round => (
              <div key={round.roundNumber} className="round-item">
                <div className="round-header">
                  <span className="round-number">第 {round.roundNumber} 轮</span>
                  <span className="round-time">
                    {round.startTime ? new Date(round.startTime * 1000).toLocaleString() : '时间未知'}
                  </span>
                </div>
                <div className="round-info">
                  <span>区块范围: {round.startHeight} - {round.endHeight}</span>
                </div>
                <div className="round-lucky-numbers">
                  {round.luckyNumbers.map((lucky, idx) => (
                    <div 
                      key={idx} 
                      className={`mini-ball ${idx < 6 ? 'red' : 'blue'}`} 
                      title={`点击查看幸运数字 #${idx + 1} 详情`}
                      onClick={() => onBallClick(idx, lucky)}
                    >
                      {lucky.error ? '?' : lucky.number}
                    </div>
                  ))}
                </div>
              </div>
            ))}
          </div>
        )}
      </div>

      {hasMore && (
        <div className="history-actions">
          <button 
            className="load-history-btn" 
            onClick={onLoadHistory}
            disabled={loading}
          >
            {loading ? '加载中...' : (hasRounds ? '加载更多历史数据' : '加载历史数据')}
          </button>
        </div>
      )}
      
      {!hasMore && hasRounds && (
        <div className="history-actions">
          <p className="no-more-data">已加载全部历史数据</p>
        </div>
      )}
    </div>
  );
};

export default HistoryRounds;
